<div class="folder-search">
  <span (click)="openSearchModal()" class="link">{{'SHARED.Advanced_search' | translate}}</span>
</div>
